/**
 * This module renders a list of language options inside the language selector element.
 * It also highlights the currently selected language based on the given language code.
 *
 * @author Akash Salvi <akash.salvi@helpshift.com>
 * @created May 13, 2025
 * @module pages/internationalization/languageDropdown
 */
import {I18N_LANGUAGE_OPTIONS} from "constants/modals/i18nLanguageOptions";

const langContainer = document.getElementById("language-selector");

/**
 * Renders language options and highlights the currently selected
 * language based on the provided language code.
 *
 * @param {string} langCode - The language code to highlight as selected.
 */
export const renderLangOptions = (langCode) => {
  langContainer.innerHTML = "";

  I18N_LANGUAGE_OPTIONS.forEach((lang) => {
    const span = document.createElement("span");

    span.textContent = lang.label;
    span.className = `tw-cursor-pointer ${
      lang.value === langCode ? "tw-text-blue-300 tw-font-semibold" : ""
    }`;
    span.dataset.lang = lang.value;

    langContainer.appendChild(span);
  });
};
